'use client'

import { useEffect } from 'react'
import { useRouter } from 'next/navigation'
import { useAuthStore } from '@/store/auth.store'
import Image from 'next/image'

const ROLE_HOME: Record<string, string> = {
  saas_admin: '/saas/dashboard',
  escola_admin: '/admin/dashboard',
  instrutor: '/instrutor/dashboard',
  aluno: '/aluno/dashboard',
}

export default function HomePage() {
  const router = useRouter()
  const { isAuthenticated, user } = useAuthStore()

  useEffect(() => {
    if (isAuthenticated && user) {
      router.replace(ROLE_HOME[user.role] || '/login')
    } else {
      router.replace('/login')
    }
  }, [isAuthenticated, user, router])

  return (
    <div className="min-h-screen flex flex-col items-center justify-center" style={{ background: 'var(--c-page)' }}>
      <Image
        src="/images/logos/strada.png"
        alt="STRADA"
        width={300}
        height={80}
        className="object-contain"
        style={{ height: '56px', width: 'auto' }}
        priority
        unoptimized
      />
      <div className="mt-4 text-xs font-medium" style={{ color: 'var(--c-text-muted)', letterSpacing: '0.08em' }}>
        A CARREGAR...
      </div>
    </div>
  )
}
